module.exports = __webpack_public_path__ + "static/img/specialarea.64844e0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/specialarea.png
// module id = vbCJ
// module chunks = 0